import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesShowcase = () => {
  const features = [
    {
      id: 1,
      icon: "MessageSquare",
      title: "Интеллектуальные диалоги",
      description: "AI понимает контекст и намерения клиентов, обеспечивая естественное общение на русском и английском языках",
      stats: "95% точность понимания",
      gradient: "from-[#00D4FF] to-[#0EA5E9]"
    },
    {
      id: 2,
      icon: "Workflow",
      title: "Автоматизация процессов",
      description: "Настройте сложные бизнес-процессы без программирования. От приема заказов до управления доставкой",
      stats: "85% сокращение времени",
      gradient: "from-[#9D4EDD] to-[#7C3AED]"
    },
    {
      id: 3,
      icon: "BarChart3",
      title: "Аналитика в реальном времени",
      description: "Отслеживайте ключевые метрики, анализируйте поведение клиентов и оптимизируйте стратегии",
      stats: "Более 50 метрик",
      gradient: "from-[#10B981] to-[#059669]"
    },
    {
      id: 4,
      icon: "Shield",
      title: "Корпоративная безопасность",
      description: "Шифрование данных, соответствие GDPR и локальным требованиям Казахстана",
      stats: "100% защита данных",
      gradient: "from-[#F59E0B] to-[#D97706]"
    },
    {
      id: 5,
      icon: "Plug",
      title: "Бесшовная интеграция",
      description: "Подключайте CRM, ERP, платежные системы и другие инструменты через готовые API",
      stats: "50+ интеграций",
      gradient: "from-[#EF4444] to-[#DC2626]"
    },
    {
      id: 6,
      icon: "Users",
      title: "Командная работа",
      description: "Совместный доступ, распределение задач и контроль качества для всей команды",
      stats: "Неограниченные пользователи",
      gradient: "from-[#00D4FF] to-[#9D4EDD]"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-[#0F172A] to-[#0A0E27]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-[#1E293B] rounded-full px-6 py-3 mb-6">
              <Icon name="Sparkles" size={20} color="#00D4FF" />
              <span className="text-sm font-medium text-[#00D4FF]">
                Возможности платформы
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-headline font-bold text-white mb-4">
              От реактивных к предиктивным
              <br />
              <span className="bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] bg-clip-text text-transparent">
                бизнес-операциям
              </span>
            </h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Комплексная платформа для автоматизации клиентского сервиса с использованием передовых технологий искусственного интеллекта
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features?.map((feature, index) => (
              <div
                key={feature?.id}
                className="group bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-[#00D4FF]/50 transition-all duration-300 hover:transform hover:scale-105 shadow-[0_0_20px_rgba(255,255,255,0.2)]"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${feature?.gradient} rounded-xl flex items-center justify-center mb-4 group-hover:shadow-lg transition-shadow duration-300`}>
                  <Icon name={feature?.icon} size={28} color="#FFFFFF" />
                </div>

                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature?.title}
                </h3>

                <p className="text-gray-300 text-sm leading-relaxed mb-4">
                  {feature?.description}
                </p>

                <div className="flex items-center space-x-2 text-[#00D4FF] text-sm font-medium">
                  <Icon name="TrendingUp" size={16} />
                  <span>{feature?.stats}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="inline-flex flex-col sm:flex-row items-center gap-4">
              <button
                onClick={() => window.location.href = '/demo-playground'}
                className="px-8 py-4 bg-gradient-to-r from-[#00D4FF] to-[#9D4EDD] text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center space-x-2 shadow-[0_0_15px_rgba(255,255,255,0.3)] border border-white"
              >
                <span>Попробовать бесплатно</span>
                <Icon name="ArrowRight" size={20} />
              </button>
              <button
                onClick={() => window.location.href = '/pricing-plans'}
                className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-xl border border-white hover:bg-white/20 transition-all duration-300 flex items-center space-x-2 shadow-[0_0_15px_rgba(255,255,255,0.3)]"
              >
                <span>Посмотреть тарифы</span>
                <Icon name="DollarSign" size={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesShowcase;